import { render } from "./DFImage.vue?vue&type=template&id=d1596694&scoped=true"
import script from "./DFImage.vue?vue&type=script&lang=js"
export * from "./DFImage.vue?vue&type=script&lang=js"

import "./DFImage.vue?vue&type=style&index=0&id=d1596694&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1596694"]])

export default __exports__